import { Box, Center, Text } from "@chakra-ui/layout";
import { Button, AspectRatio } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import { IResourceCategory } from "../models/resourceCategory";
import { If, Then } from "react-if";
import React, { memo } from "react";
import FluidImage from "@modules/Layout/components/FluidImage";

interface IProps {
  item: IResourceCategory;
  handleOpenModal: () => void;
  isOpen: boolean;
}

const InstallationCard: React.FC<IProps> = ({
  item,
  isOpen,
  handleOpenModal,
}) => {
  const { thumbnail, name } = item.attributes;

  return (
    <Box>
      <Center
        bg="white10"
        h={"16rem"}
        color="white"
        mb={"1rem"}
        mt={"1rem"}
        borderRadius={"7px"}
        overflow={"hidden"}
        onClick={handleOpenModal}
      >
        <If condition={thumbnail.data !== null}>
          <Then>
            <AspectRatio
              ratio={1}
              w="100%"
              h="100%"
              borderRadius={"7px"}
              overflow={"hidden"}
            >
              <FluidImage imageItem={thumbnail} heightFluidImage={"100%"} />
            </AspectRatio>
          </Then>
        </If>
      </Center>

      <Text textStyle={"h6"} mb={2}>
        {name}
      </Text>

      <Button
        onClick={handleOpenModal}
        fontSize={"m"}
        color={"primary"}
        fontWeight={700}
        textStyle={"hind_m"}
        variant={"ghost"}
        px={0}
        isDisabled={isOpen}
      >
        View Demo
        <ArrowForwardIcon color={"primary"} boxSize={5} ml={2} />
      </Button>
    </Box>
  );
};

export default memo(InstallationCard);
